import { Route, Routes } from 'react-router-dom';

import { usePageTypeByFeatureFlag } from 'hooks/usePageTypeByFF';

import RollingOfferForm from './Form/RollingOfferForm';
import RollingOffersTable from './RollingOffersTable';

const RollingOffersView = () => {
  const { isPageDisabled } = usePageTypeByFeatureFlag('Rolling');

  return (
    <Routes>
      <Route
        path="/"
        element={isPageDisabled ? <RollingOfferForm /> : <RollingOffersTable />}
      />
      <Route path="/form" element={<RollingOfferForm />} />
      <Route
        path="/form/:rollingOfferId"
        element={<RollingOfferForm edit={true} />}
      />
      <Route
        path="/dup/:rollingOfferId"
        element={<RollingOfferForm edit={false} dup={true} />}
      />
    </Routes>
  );
};

export default RollingOffersView;
